import React from 'react';

const DropdownFilter = props => {
    const { options = [], selected, placeholder, onChange, 'data-testid': dataTestId } = props;

    return (
        <div className="row">
            <div className="col">
                <select
                    className="form-control"
                    value={selected}
                    onChange={(e) => onChange(e.target.value)}
                    data-testid={dataTestId}
                >
                    {placeholder && <option value="">{placeholder}</option>}
                    {options.map(option => <option value={option.value} key={option.value}>{option.description}</option>)}
                </select>
            </div>
        </div>
    );
};

export default DropdownFilter;
